import gql from 'graphql-tag'

export const CREATE_NEW_WALLET = gql`
  mutation createNewWallet($type: String) {
    createNewWallet(type: $type)
  }
`;